import { render, staticRenderFns } from "./HandoversView.vue?vue&type=template&id=4b90d5b8&scoped=true"
import script from "./HandoversView.vue?vue&type=script&lang=js"
export * from "./HandoversView.vue?vue&type=script&lang=js"
import style0 from "./HandoversView.vue?vue&type=style&index=0&id=4b90d5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b90d5b8",
  null
  
)

export default component.exports